import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTheme } from '@mui/material';

const Badge = ({ type, text }) => {
  const theme = useTheme();
  const badgeStyles = {
    base: {
      padding: "4px",
      borderRadius: "8px",
      textAlign: "center",
      minWidth: "60px",
    },
    types: {
      success: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.text.secondary,
      },
      error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.text.secondary,
      },
      warning: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.text.default,
      },
      info: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
    },
  };
  const style = {
    ...badgeStyles.base,
    ...(badgeStyles.types[type] || {}),
  };
  
  return (
    <Typography
        variant="subtitle2"
        style={style}
    >
        {text}
    </Typography>
  )
};

// Prop validation
Badge.propTypes = {
  type: PropTypes.oneOf(["success", "error", "warning", "info"]).isRequired,
  text: PropTypes.string.isRequired,
};

export default Badge;
